import { render, staticRenderFns } from "./DashboardReadsCard.vue?vue&type=template&id=12e5741f"
import script from "./DashboardReadsCard.vue?vue&type=script&lang=js"
export * from "./DashboardReadsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports